import React from 'react';
import DeliveryStatus from '../DeliveryStatus';
import { processLocation } from '../../utils/locationUtils';
import './EmployeeTable.css';

function EmployeeTable({ employees, goodieTypes, goodies, onViewModify }) {
  return (
    <div className="dashboard-table-container">
      <table className="dashboard-table">
        <thead>
          <tr>
            <th>Employee ID</th>
            <th>Name</th>
            <th>Location</th>
            {goodieTypes.map(goodieType => (
              <th key={goodieType}>{goodieType}</th>
            ))}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {employees.map(employee => (
            <tr key={employee.empId || employee.emp_id}>
              <td className="emp-id">{employee.empId || employee.emp_id}</td>
              <td className="emp-name">
                {employee.firstName || employee.first_name} {employee.lastName || employee.last_name}
              </td>
              <td className="emp-location">{processLocation(employee.location) || 'Remote'}</td>
              {goodieTypes.map((goodieType, index) => {
                // Find the goodie from the master goodies list by matching the display name
                const goodieFromMasterList = goodies.find(g => 
                  g.name && g.name.charAt(0).toUpperCase() + g.name.slice(1) === goodieType
                );
                
                // Check if employee has collected this goodie by matching the goodie ID
                let currentStatus = 'not-delivered';
                if (employee.goodies && Array.isArray(employee.goodies) && goodieFromMasterList) {
                  const employeeGoodie = employee.goodies.find(g => g.id === goodieFromMasterList.id);
                  if (employeeGoodie && employeeGoodie.received === true) {
                    currentStatus = 'delivered';
                  }
                }
                
                return (
                  <td key={goodieType} className="goodie-status">
                    <DeliveryStatus 
                      status={currentStatus} 
                      variant="default" 
                      size="medium" 
                    />
                  </td>
                );
              })}
              <td className="actions">
                <button
                  className="view-modify-link"
                  onClick={() => onViewModify(employee)}
                >
                  View & Modify
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default EmployeeTable;
